import { CalendarDays, Download, MapPin, Save, Sparkles, Trash2, X } from "lucide-react";
import { useEffect, useState } from "react";

function splitTags(value) {
  return value.split(/[，,]/).map((tag) => tag.trim()).filter(Boolean);
}

export function PhotoDetails({ photo, onClose, onSave, onDelete }) {
  const [title, setTitle] = useState("");
  const [location, setLocation] = useState("");
  const [styles, setStyles] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    setTitle(photo?.title || "");
    setLocation(photo?.location || "");
    setStyles((photo?.styles || []).join("，"));
  }, [photo]);

  if (!photo) return null;

  async function save() {
    setSaving(true);
    try {
      await onSave(photo, { title, location, styles: splitTags(styles) });
    } finally {
      setSaving(false);
    }
  }

  return (
    <aside className="details-panel" aria-label="照片详情">
      <button className="icon-button details-close" type="button" onClick={onClose} aria-label="关闭详情">
        <X size={23} strokeWidth={1.3} />
      </button>
      <div className="details-preview">
        <img src={photo.thumbUrl} alt="" />
      </div>
      <label className="field title-field">
        <span>照片名</span>
        <input value={title} onChange={(event) => setTitle(event.target.value)} disabled={photo.isDemo} />
      </label>

      <div className="details-meta">
        <div><CalendarDays size={17} strokeWidth={1.4} /><span>{new Date(photo.capturedAt).toLocaleString("zh-CN", { hour12: false })}</span></div>
        <div><MapPin size={17} strokeWidth={1.4} /><span>{photo.location}</span></div>
        <div><Sparkles size={17} strokeWidth={1.4} /><span>{photo.solarTerm}</span></div>
      </div>

      <label className="field">
        <span>地点</span>
        <input value={location} onChange={(event) => setLocation(event.target.value)} disabled={photo.isDemo} />
      </label>
      <label className="field">
        <span>风格 <small>用逗号分隔</small></span>
        <input value={styles} onChange={(event) => setStyles(event.target.value)} disabled={photo.isDemo} />
      </label>

      {photo.isDemo ? (
        <p className="demo-note">这是演示照片。导入你的照片后，可在这里修改地点与风格。</p>
      ) : (
        <button className="save-button" type="button" onClick={save} disabled={saving}>
          <Save size={16} strokeWidth={1.5} /> {saving ? "保存中…" : "保存修改"}
        </button>
      )}

      <div className="details-footer">
        <a className="text-button" href={`${photo.originalUrl}${photo.originalUrl.includes("?") ? "&" : "?"}download=1`}>
          <Download size={15} /> 下载原图
        </a>
        {!photo.isDemo && (
          <button className="danger-button" type="button" onClick={() => onDelete(photo)}>
            <Trash2 size={15} /> 删除
          </button>
        )}
      </div>
    </aside>
  );
}
